export default __webpack_public_path__ + "static/media/vaccination.c7186433.svg";